"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ApplicationSelector_1 = require("./Selector/ApplicationSelector");
var ServiceSelector_1 = require("./Selector/ServiceSelector");
var KeyTokenTableComponent_1 = require("./KeyTokenTableComponent");
var ModalRegisterKeyTokenComponent_1 = require("./ModalRegisterKeyTokenComponent");
var KeyToken = /** @class */ (function (_super) {
    __extends(KeyToken, _super);
    function KeyToken(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            appId: "",
            serviceId: "",
            loadState: false,
            serviceLoad: false,
            getToken: false
        };
        _this.hookAppsId = _this.hookAppsId.bind(_this);
        _this.hookServiceId = _this.hookServiceId.bind(_this);
        _this.setGetTokenTrue = _this.setGetTokenTrue.bind(_this);
        _this.setGetTokenFalse = _this.setGetTokenFalse.bind(_this);
        return _this;
    }
    KeyToken.prototype.hookAppsId = function (id) {
        this.setState({
            appId: id,
            serviceId: "",
            loadState: true,
            serviceLoad: true
        });
    };
    KeyToken.prototype.hookServiceId = function (appId, serId) {
        this.setState({
            appId: appId,
            serviceId: serId,
            loadState: true,
            serviceLoad: false
        });
    };
    KeyToken.prototype.setGetTokenTrue = function () {
        this.setState({
            getToken: true
        });
    };
    KeyToken.prototype.setGetTokenFalse = function () {
        this.setState({
            getToken: false
        });
    };
    KeyToken.prototype.render = function () {
        var _a = this.state, appId = _a.appId, serviceId = _a.serviceId, serviceLoad = _a.serviceLoad, getToken = _a.getToken;
        return (React.createElement("div", { style: { paddingLeft: 'unset' } },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement(ApplicationSelector_1.default, { hookAppsId: this.hookAppsId })),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement(ServiceSelector_1.default, { hookServiceId: this.hookServiceId.bind(this), appId: appId, serviceLoad: serviceLoad }))),
            React.createElement("div", null,
                React.createElement(ModalRegisterKeyTokenComponent_1.default, { setGetTokenTrue: this.setGetTokenTrue.bind(this), appId: appId, serviceId: serviceId })),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("h4", null, "Key")),
                React.createElement("div", { className: "col-md-12" },
                    React.createElement(KeyTokenTableComponent_1.default, { setGetTokenFalse: this.setGetTokenFalse.bind(this), appId: appId, serviceId: serviceId, getToken: getToken })))));
    };
    return KeyToken;
}(React.Component));
exports.default = KeyToken;
//# sourceMappingURL=KeyToken.js.map